// This file was generated by lezer-generator. You probably shouldn't edit it.
export const
  inf = 179,
  nan = 180,
  Bool = 1,
  Ignoring = 2,
  On = 3,
  GroupLeft = 4,
  GroupRight = 5,
  Offset = 6,
  Outer = 7,
  Atan2 = 8,
  Avg = 9,
  Bottomk = 10,
  Count = 11,
  CountValues = 12,
  CardinalityEstimate = 13,
  Group = 14,
  Max = 15,
  Min = 16,
  Quantile = 17,
  LimitK = 18,
  LimitRatio = 19,
  Stddev = 20,
  Stdvar = 21,
  Sum = 22,
  Topk = 23,
  By = 24,
  Without = 25,
  And = 26,
  Or = 27,
  Unless = 28,
  Start = 29,
  End = 30,
  LineComment = 31,
  PromQL = 32,
  AggregateExpr = 33,
  AggregateOp = 34,
  TemplateVariable = 35,
  AggregateModifier = 36,
  GroupingLabels = 37,
  LabelName = 38,
  QuotedLabelName = 39,
  FunctionCallBody = 40,
  BinaryExpr = 41,
  Pow = 42,
  BoolModifier = 43,
  OuterModifier = 44,
  MatchingModifierClause = 45,
  Mul = 46,
  Div = 47,
  Mod = 48,
  Add = 49,
  Sub = 50,
  Eql = 51,
  Gte = 52,
  Gtr = 53,
  Lte = 54,
  Lss = 55,
  Neq = 56,
  FunctionCall = 57,
  FunctionIdentifier = 58,
  AbsentOverTime = 59,
  Identifier = 60,
  Absent = 61,
  Abs = 62,
  Acos = 63,
  Acosh = 64,
  Asin = 65,
  Asinh = 66,
  Atan = 67,
  Atanh = 68,
  AvgOverTime = 69,
  Ceil = 70,
  Changes = 71,
  Clamp = 72,
  ClampMax = 73,
  ClampMin = 74,
  Cos = 75,
  Cosh = 76,
  CountOverTime = 77,
  DaysInMonth = 78,
  DayOfMonth = 79,
  DayOfWeek = 80,
  DayOfYear = 81,
  Deg = 82,
  Delta = 83,
  Deriv = 84,
  Exp = 85,
  Floor = 86,
  HistogramCount = 87,
  HistogramFraction = 88,
  HistogramQuantile = 89,
  HistogramStdDev = 90,
  HistogramStdVar = 91,
  HistogramSum = 92,
  HistogramAvg = 93,
  HoltWinters = 94,
  DoubleExponentialSmoothing = 95,
  Hour = 96,
  Idelta = 97,
  Increase = 98,
  Info = 99,
  Irate = 100,
  LabelReplace = 101,
  LabelJoin = 102,
  LastOverTime = 103,
  Ln = 104,
  Log10 = 105,
  Log2 = 106,
  MadOverTime = 107,
  MaxOverTime = 108,
  MinOverTime = 109,
  Minute = 110,
  Month = 111,
  Pi = 112,
  PredictLinear = 113,
  PresentOverTime = 114,
  QuantileOverTime = 115,
  Rad = 116,
  Rate = 117,
  Resets = 118,
  Round = 119,
  Scalar = 120,
  Sgn = 121,
  Sin = 122,
  Sinh = 123,
  Sort = 124,
  SortDesc = 125,
  SortByLabel = 126,
  SortByLabelDesc = 127,
  Sqrt = 128,
  StddevOverTime = 129,
  StdvarOverTime = 130,
  SumOverTime = 131,
  Tan = 132,
  Tanh = 133,
  Timestamp = 134,
  Time = 135,
  Vector = 136,
  Year = 137,
  HistogramObservations = 138,
  HistogramQuantiles = 139,
  SortHeadAvg = 140,
  SortHeadMin = 141,
  SortHeadMax = 142,
  SortHeadSum = 143,
  SortHeadCount = 144,
  SortTailAvg = 145,
  SortTailMin = 146,
  SortTailMax = 147,
  SortTailSum = 148,
  SortTailCount = 149,
  SumPerSecond = 150,
  TsOfFirstOverTime = 151,
  TsOfLastOverTime = 152,
  TsOfMinOverTime = 153,
  TsOfMaxOverTime = 154,
  MatrixSelector = 155,
  Duration = 156,
  NumberLiteral = 157,
  OffsetExpr = 158,
  ParenExpr = 159,
  StringLiteral = 160,
  SubqueryExpr = 161,
  UnaryExpr = 162,
  UnaryOp = 163,
  VectorSelector = 164,
  LabelMatchers = 165,
  LabelMatcher = 166,
  MatchOp = 167,
  EqlSingle = 168,
  EqlRegex = 169,
  NeqRegex = 170,
  StepInvariantExpr = 171,
  At = 172,
  AtModifierPreprocessors = 173,
  MetricName = 174
